export default __webpack_public_path__ + "static/media/domagoj-praljak.04268295.jpeg";